module.exports = __webpack_public_path__ + "img/allstate.c95e8829.png";